import { render, staticRenderFns } from "./BienDetailsSharePopin.vue?vue&type=template&id=2ba570fc&scoped=true"
import script from "./BienDetailsSharePopin.vue?vue&type=script&lang=js"
export * from "./BienDetailsSharePopin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba570fc",
  null
  
)

export default component.exports